<!-- List View Layout -->
<ng-container *ngIf="DisplayStyle == 'List'">
  <div class="d-flex flex-wrap gap-2 align-items-center mb-1">
    <!-- Electronic Resource Button -->
    <button *ngIf="book856.length > 0" (click)="open(content)" style="height: 30px;" class="d-inline-flex align-items-center 
      px-3 py-0 btn btn-sm btn-light btn-light-walai 
      border rounded-pill text-dark px-3 shadow-none">
      <i class="fas fa-globe-asia me-2"></i>
      <span class="small fw-semibold">{{ 'ElectronicResource' | translate }}</span>
    </button>

    <!-- MatType Badge -->
    <div *ngIf="matTypeName" style="height: 30px;"
      class="badge rounded-pill bg-white text-secondary border border-light  d-inline-flex align-items-center px-3 py-0">
      <img width="18" height="18" class="me-2 opacity-75" src="assets/images/Mattype/{{ matTypeName }}.png"
        alt="{{ matTypeName }}" />
      <span class="small fw-normal text-dark">{{ matTypeName }}</span>
    </div>

    <!-- Status: Available -->
    <div *ngIf="status == 'Available'" style="height: 30px;"
      class="badge rounded-pill bg-success-subtle text-success  d-inline-flex align-items-center px-3 py-0">
      <i class="bi bi-check-circle-fill me-2"></i>
      <span class="small fw-semibold">{{ 'Available' | translate }}</span>
    </div>

    <!-- Status: Not Available -->
    <div *ngIf="status == 'Not Available'" style="height: 30px;"
      class="badge rounded-pill bg-warning-subtle text-warning-emphasis border border-warning-subtle d-inline-flex align-items-center px-3 py-0">
      <i class="bi bi-exclamation-circle-fill me-2"></i>
      <span class="small fw-semibold">{{ 'NotAvailable' | translate }}</span>
    </div>
  </div>
</ng-container>

<!-- Grid View Layout (Compact) -->
<ng-container *ngIf="DisplayStyle == 'Table'">
  <div class="d-flex flex-wrap gap-1 align-items-center justify-content-center mt-2">
    <!-- Electronic Resource Button (Compact) -->
    <button *ngIf="book856.length > 0" (click)="open(content)"
      style="height: 24px; font-size: 0.7rem; position: relative; z-index: 10;"
      class="btn btn-sm btn-light btn-light-walai border d-inline-flex align-items-center rounded-pill text-dark shadow-none">
      <i class="fas fa-globe-asia me-1"></i>
      <span class="fw-semibold">{{ 'E-Resource' | translate }}</span>
    </button>

    <!-- MatType Badge (Compact) -->
    <div *ngIf="matTypeName" style="height: 24px; font-size: 0.7rem;" [title]="matTypeName"
      class="badge rounded-pill bg-white text-secondary border border-light d-inline-flex align-items-center px-2 py-0">
      <img width="14" height="14" class="me-1 opacity-75" src="assets/images/Mattype/{{ matTypeName }}.png"
        alt="{{ matTypeName }}" />
      <span *ngIf="showSecondaryText" class="fw-normal text-dark text-truncate" style="max-width: 60px;">{{ matTypeName
        }}</span>
    </div>

    <!-- Status: Available (Compact) -->
    <div *ngIf="status == 'Available'" style="height: 24px; font-size: 0.7rem;" title="Available"
      class="badge rounded-pill bg-success-subtle text-success d-inline-flex align-items-center px-2 py-0">
      <i class="bi bi-check-circle-fill" [class.me-1]="showSecondaryText"></i>
      <span *ngIf="showSecondaryText" class="fw-semibold">{{ 'Available' | translate }}</span>
    </div>

    <!-- Status: Not Available (Compact) -->
    <div *ngIf="status == 'Not Available'" style="height: 24px; font-size: 0.7rem;" title="Not Available"
      class="badge rounded-pill bg-warning-subtle text-warning-emphasis border border-warning-subtle d-inline-flex align-items-center px-2 py-0">
      <i class="bi bi-exclamation-circle-fill" [class.me-1]="showSecondaryText"></i>
      <span *ngIf="showSecondaryText" class="fw-semibold">{{ 'NotAvailable' | translate }}</span>
    </div>
  </div>
</ng-container>



<!-- <a class="btn bg-warning  button-radius1 btn-walai-default text-white" 
          style="cursor:default;"
          *ngIf="status=='Not Available'" >
            Not Available
          </a> -->

<ng-template #content let-modal>
  <!-- Modern Header -->
  <div class="modal-header border-0 pb-2 pt-4 px-4 align-items-start">
    <div>
      <h5 class="modal-title fw-bold text-primary d-flex align-items-center gap-2" id="modal-basic-title">
        <i class="fas fa-globe-asia"></i> {{ 'ElectronicResource' | translate }}
      </h5>
      <p class="mb-0 text-secondary small mt-1 opacity-75">{{ 'SelectResourceLink' | translate }}</p>
    </div>
    <button type="button" class="btn-close bg-light rounded-circle p-2 ms-auto" aria-label="Close"
      (click)="modal.dismiss('Cross click')"></button>
  </div>

  <!-- Content Body -->
  <div class="modal-body px-4 pb-4">
    <div class="d-flex flex-column gap-3">
      <ng-container *ngFor="let info of book856">
        <a (click)="addHistory(info.URL)" [href]="info.URL" target="_blank"
          class="position-relative d-flex align-items-center p-3 rounded-4 bg-white border border-light shadow-sm text-decoration-none resource-card-hover"
          style="transition: all 0.2s ease;">

          <!-- Icon -->
          <div
            class="flex-shrink-0 bg-primary-subtle text-primary rounded-3 d-flex align-items-center justify-content-center me-3"
            style="width: 48px; height: 48px;">
            <i class="bi bi-link-45deg fs-4"></i>
          </div>

          <!-- Text Info -->
          <div class="flex-grow-1 overflow-hidden">
            <div *ngIf="info.label" class="text-uppercase text-secondary fw-bold mb-1"
              style="font-size: 0.7rem; letter-spacing: 0.5px;">
              {{ info.label }}
            </div>
            <div class="text-dark fw-semibold text-truncate" [title]="info.name">
              {{ info.name }}
            </div>
            <div class="text-muted small text-truncate opacity-75 mt-0" style="font-size: 0.8rem;">
              {{ info.URL }}
            </div>
          </div>

          <!-- Action Icon -->
          <div class="ms-3 text-secondary opacity-25 action-icon">
            <i class="bi bi-chevron-right"></i>
          </div>
        </a>
      </ng-container>
    </div>
  </div>
</ng-template>

<!-- <span class="border-end border-1 border-secondary mx-3"></span> -->